import { OAuthCallbackKey } from '@common/oAuth/constants';
import { useSearchParams } from 'react-router-dom';

export default function OAuthCallback() {
  const [searchParams] = useSearchParams();

  window.opener?.window.postMessage(
    {
      type: OAuthCallbackKey,
      payload: { code: searchParams.get('code'), state: searchParams.get('state') }
    },
    '*'
  );
  return null;
}
